//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObjectCollection.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["port_1","port_2"],"CreatePortConnection",{R_:{port_connection:"Routing.PortConnection"}},2,0],[["port_1","port_2"],"CanPortsConnect",{R_:{can_ports_connect:''}},2,0],[["port"],"GetConnectionFromPort",{R_:{portConnection:"Routing.PortConnection"}},1,0]],[]];
SPLM.Routing.PortConnectionCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.PortConnectionCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Routing.PortConnectionCollection.PortsStatus = Object.freeze({
    "CanConnect" : "CanConnect", "CannotConnect" : "CannotConnect"});

export default SPLM;